export const Constants = {
    API_URL: 'https://carron-lodge.fusionweb.cloud/api',
    REVERB_HOST: 'ws.carron-lodge.fusionweb.cloud',
    REVERB_PORT: 80,
    REVERB_APP_ID: '792923',
    REVERB_APP_KEY: 'h2iuq4it24isamt79wtw',
    REVERB_APP_SECRET: '3pxhnalvdmki8qminxic',
};